<epc-servicenow-virtual-agent></epc-servicenow-virtual-agent>
<div class="safe-area-top"></div>

<router-outlet name="main-navigation"></router-outlet>

<ng-container
  *epcFeatureFlag="
    showSpotLightFeatureFlag;
    namespace: showSpotlightNamespace;
    equality: true;
    defaultValue: true
  "
>
  @if (recommendationPanelHasNoItems$ | async) {
  <router-outlet name="spotlight"></router-outlet>
  }
</ng-container>

@if (shouldShowSpotlightPanel$ | async) {
<epc-recommendation-panel
  [location]="spotlightRecommendationPanel"
  (hasItems)="recommendationPanelHasItems$.next($event)"
></epc-recommendation-panel>
}

<main>
  <router-outlet></router-outlet>
</main>

<router-outlet name="footer"></router-outlet>

<epc-side-pane></epc-side-pane>

<epc-main-overlay></epc-main-overlay>
